import React, { createContext, useState, useEffect, useContext } from 'react'
import i18n from '../i18n'
import appBridge from 'libs/appBridge'
import Loading from 'components/Loading'
import { Alert } from '@shopline/dashboard-ui'

const AdminExtensionContext = createContext()

export const useAdminExtension = () => useContext(AdminExtensionContext)

export const AdminExtensionProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    const appBridgeInit = async () => {
      const initResult = await appBridge.init({
        clientId: process.env.REACT_APP_SSO_CLIENT_ID,
      })

      const sessionToken = await appBridge?.client?.getSessionToken()

      if (initResult !== 'success' && sessionToken === undefined) {
        setIsValid(false)
        setIsLoading(false)
        return
      }

      const lang = await appBridge.client.getLanguage()
      i18n.changeLanguage(lang)
      appBridge.client.onLanguageChanged(function (lang) {
        i18n.changeLanguage(lang)
      })

      setIsValid(true)
      setIsLoading(false)
    }

    appBridgeInit()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  if (!isValid) {
    return (
      <div className="w-75 mx-auto vh-100 d-flex justify-content-center align-items-center">
        <Alert.Destructive>Please use SHOPLINE to open this web service</Alert.Destructive>
      </div>
    )
  }

  return (
    <AdminExtensionContext.Provider
      value={{
        isLoading,
        isValid,
      }}
    >
      {children}
    </AdminExtensionContext.Provider>
  )
}
